import { z } from 'zod';

// The rules of a member's account, shared by the API (the CLI from A1, the login and the admin API
// from A2 and A4) and the web (the login and the admin forms from A3 and A5). D5 and D15: a member
// is a username, a display name, a role, a status and a password; nothing else is stored.

export const ROLES = ['admin', 'member'] as const;
export const Role = z.enum(ROLES);
export type Role = z.infer<typeof Role>;

export const MEMBER_STATUSES = ['active', 'disabled'] as const;
export const MemberStatus = z.enum(MEMBER_STATUSES);
export type MemberStatus = z.infer<typeof MemberStatus>;

/** The longest username and display name: the rules below, for the forms' inputs (A5). */
export const USERNAME_MAX_LENGTH = 32;
export const DISPLAY_NAME_MAX_LENGTH = 60;

/**
 * What a member types to log in, stored lowercase: 3 to 32 of a-z, 0-9, dot, underscore and
 * hyphen, starting and ending with a letter or a digit. Plain ASCII, so any phone's keyboard types
 * it; a name with Turkish letters goes in the display name.
 */
export const Username = z
  .string()
  .trim()
  .toLowerCase()
  .regex(/^[a-z0-9][a-z0-9._-]{1,30}[a-z0-9]$/);

/** The name the other members see on the boards and the events: 1 to 60 characters. */
export const DisplayName = z.string().trim().min(1).max(DISPLAY_NAME_MAX_LENGTH);

/** A new password: 8 to 256 characters, any of them, no other rule (NIST SP 800-63B). */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;
export const NewPassword = z.string().min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH);
